/*====================================
=            All pages             =
====================================*/


     /* Smooth scroll  ----------------*/

    $('a[href*=#]:not([href=#])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') 
          || location.hostname == this.hostname) {

          var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({
           scrollTop: target.offset().top -90
         }, 1000);
          return false;
        }
      }
      });




/* Update cart poduct quantity label  ----------------*/

$( "body" ).on( "afterAddItem.ajaxCart afterChangeItem.ajaxCart", function( event ) {
    //console.log("after ajax add or change item");
 

    jQuery.getJSON('/cart.js', function(cart) {
      //console.log(cart);
      //updateTotalPrice(cart);

      $(".cart_amount_label").show(); // if hidden
      $(".cart_amount_label").html(cart.item_count);
      if(cart.item_count == 0) {
        $(".cart_amount_label").hide();
      }

    } );


});

  

